<div class="container-vehicle">
    <img src="/assets/img/tacho/empty-state-tacho.svg" alt="">
    <span class="title">
        {{'noDriverCardInTheReader'| translate}}
    </span>
    <span class="description">
        {{'noDriverCardInTherReaderDescription'|translate}}
    </span>
</div>
